/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type VerifyExpertDocumentResponseDto = {
    /**
     * Expert document ID
     */
    id: string;
    /**
     * Expert ID who owns the document
     */
    expertId: string;
    /**
     * Type of expert document
     */
    documentType: VerifyExpertDocumentResponseDto.documentType;
    /**
     * Updated document status
     */
    status: VerifyExpertDocumentResponseDto.status;
    /**
     * Timestamp when the document was verified
     */
    verifiedAt: Record<string, any> | null;
    /**
     * Rejection reason if the document was rejected
     */
    rejectionReason: string | null;
};
export namespace VerifyExpertDocumentResponseDto {
    /**
     * Type of expert document
     */
    export enum documentType {
        CPR_CERTIFICATION = 'cpr_certification',
        FIRST_AID_CERTIFICATION = 'first_aid_certification',
        PT_CERTIFICATION = 'pt_certification',
        HIGHEST_EDUCATION = 'highest_education',
        BACHELORS_DEGREE = 'bachelors_degree',
        MASTERS_DEGREE = 'masters_degree',
        INTERNSHIP_CERTIFICATE = 'internship_certificate',
        PROFESSIONAL_LICENSE = 'professional_license',
        WORK_EXPERIENCE_PROOF = 'work_experience_proof',
        MA_MSC_PSYCHOLOGY = 'ma_msc_psychology',
        MPHIL_PSYD = 'mphil_psyd',
        CHILD_CERTIFICATION = 'child_certification',
        ACTIVE_LISTENING_TRAINING = 'active_listening_training',
        ADDITIONAL_CERTIFICATION = 'additional_certification',
        OTHER = 'other',
        PASSPORT = 'passport',
        EMIRATES_ID = 'emirates_id',
        AADHAR_CARD = 'aadhar_card',
    }
    /**
     * Updated document status
     */
    export enum status {
        PENDING = 'pending',
        VERIFIED = 'verified',
        REJECTED = 'rejected',
        RESUBMISSION_REQUIRED = 'resubmission_required',
    }
}

